import type { TvBenchmarkReport } from "../shared/tvBenchmark.js";

const RUNWAY_PRESET_KEY = "runwayRookies:webgl2Preset";
const RUNWAY_PRESET = "webgl2-flight-720p-30";
const BENCHMARK_RESULT_KEY = "tvGraphicsBenchmark:lastResult";

export function shouldUseRunwayWebGl2(storage: Pick<Storage, "getItem">): boolean {
  try {
    if (storage.getItem(RUNWAY_PRESET_KEY) !== RUNWAY_PRESET) return false;
    const raw = storage.getItem(BENCHMARK_RESULT_KEY);
    if (!raw) return false;
    const report = JSON.parse(raw) as Partial<TvBenchmarkReport>;
    const representative = report.webgl2?.representativeMetrics;
    const soak = report.webgl2?.soak;
    return Boolean(
      report.classification?.tier === "webgl2-enhanced" &&
      report.webgl2?.available &&
      report.webgl2.contextRecovery === "passed" &&
      representative &&
      representative.fps >= 30 &&
      representative.p95FrameMs <= 28 &&
      (representative.framesOver100Ms ?? 0) === 0 &&
      soak &&
      soak.kind === "webgl2-representative" &&
      soak.completedDurationMs >= soak.requestedDurationMs &&
      soak.aggregate.frames.fps >= 30 &&
      soak.aggregate.frames.p95FrameMs <= 28 &&
      (soak.aggregate.frames.framesOver100Ms ?? 0) === 0,
    );
  } catch {
    return false;
  }
}

export function recordRunwayRendererDiagnostic(
  storage: Pick<Storage, "setItem">,
  reason: string,
): void {
  try {
    storage.setItem(
      "runwayRookies:lastRendererDiagnostic",
      JSON.stringify({ reason, capturedAt: new Date().toISOString() }),
    );
  } catch {
    // Canvas fallback remains available when constrained TV storage rejects writes.
  }
}
